import {Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {SyncService} from '../../shared/services/sync.service';
import {PrintNoticeData} from '../../shared/models/print';
import {AbstractPrintComponent} from '../abstract-print/abstract-print.component';

@Component({
  selector: 'app-print-notice-reporting',
  templateUrl: './print-notice-reporting.component.html',
  styleUrl: './print-notice-reporting.component.scss'
})
export class PrintNoticeReportingComponent extends AbstractPrintComponent {
  @Input() data: PrintNoticeData;
  @Output() init: EventEmitter<any> = new EventEmitter<any>();

  constructor(public sync: SyncService, elRef: ElementRef) {
    super(elRef);
  }
}
